import React from 'react';

// NOTE: v1 placeholder artwork. Designer pass pending.
export default function AutumnAccessory() {
  return (
    <g aria-hidden="true">
      {/* Two big maple leaves on roof */}
      <g transform="translate(85 78) rotate(-20)">
        <path d="M0,-16 L4,-9 L11,-10 L7,-3 L14,1 L7,4 L9,12 L1,8 L0,16 L-1,8 L-9,12 L-7,4 L-14,1 L-7,-3 L-11,-10 L-4,-9 Z" fill="#E89A2E" stroke="#CD7F32" strokeWidth="1" />
        <line x1="0" y1="-12" x2="0" y2="12" stroke="#CD7F32" strokeWidth="0.8" opacity="0.7" />
      </g>
      <g transform="translate(118 80) rotate(25)">
        <path d="M0,-16 L4,-9 L11,-10 L7,-3 L14,1 L7,4 L9,12 L1,8 L0,16 L-1,8 L-9,12 L-7,4 L-14,1 L-7,-3 L-11,-10 L-4,-9 Z" fill="#E0290A" stroke="#7a1a05" strokeWidth="1" />
        <line x1="0" y1="-12" x2="0" y2="12" stroke="#7a1a05" strokeWidth="0.8" opacity="0.7" />
      </g>
      {/* Falling leaves around */}
      <g transform="translate(34 50) rotate(30)">
        <path d="M0,-12 L3,-7 L8,-8 L5,-2 L10,1 L5,3 L7,9 L1,6 L0,12 L-1,6 L-7,9 L-5,3 L-10,1 L-5,-2 L-8,-8 L-3,-7 Z" fill="#E5B941" stroke="#A8851F" strokeWidth="1" />
      </g>
      <g transform="translate(174 65) rotate(-40)">
        <path d="M0,-12 L3,-7 L8,-8 L5,-2 L10,1 L5,3 L7,9 L1,6 L0,12 L-1,6 L-7,9 L-5,3 L-10,1 L-5,-2 L-8,-8 L-3,-7 Z" fill="#CD7F32" stroke="#7a4a18" strokeWidth="1" />
      </g>
      <g transform="translate(180 120) rotate(60)">
        <path d="M0,-10 L2.5,-6 L7,-7 L4,-2 L8,1 L4,2.5 L6,7 L1,5 L0,10 L-1,5 L-6,7 L-4,2.5 L-8,1 L-4,-2 L-7,-7 L-2.5,-6 Z" fill="#E89A2E" stroke="#CD7F32" strokeWidth="1" />
      </g>
    </g>
  );
}
